import { render, staticRenderFns } from "./AppBibleAuth.vue?vue&type=template&id=b7aa3792&"
import script from "./AppBibleAuth.vue?vue&type=script&lang=js&"
export * from "./AppBibleAuth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports